import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { LocationDto } from "src/dtos/location/locationDto";
import { getData } from "src/utils/axios/serverHelper";

const locationUrl = `${config.apiUrl}/location`;

/**
 * 로케이션 팝업용 목록 조회
 * @param searchText 검색어 (로케이션코드, 로케이션명)
 * @param warehouseCd 창고코드
 * @param logicCenter 물류센터
 * @returns 로케이션 목록
 */
export const getLocationPopupList = async (
    searchText: string,
    warehouseCd?: string,
    logicCenter?: string
) => {
    const url = `${locationUrl}/popup/list`;
    
    return await getData<ResponseDto<LocationDto[]>>(url, {
        params: {
            searchText: searchText || '',
            warehouseCd: warehouseCd || '',
            logicCenter: logicCenter || ''
        }
    });
};

/**
 * 로케이션 코드로 단일 조회
 * @param locationCd 로케이션코드
 * @returns 로케이션 정보
 */
export const searchLocation = async (locationCd: string) => {
    return await getLocationPopupList(locationCd);
};
